import { render } from "./process-templates.html?vue&type=template&id=2d70f329&scoped=true&ts=true"
import script from "./process-templates.ts?vue&type=script&lang=ts"
export * from "./process-templates.ts?vue&type=script&lang=ts"

import "./process-templates.scss?vue&type=style&index=0&id=2d70f329&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d70f329"]])

export default __exports__